






























































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import * as util from "@/service/util";
@Component({
  components: {
    Header
  }
})
export default class QuickMitsumoriList extends Vue {
  data: any = [];
  dataPageList: any = [];
  currentPage = 1;
  pageSize = 10;
  torokubangoSelected = "";

  created() {
    // data test
    for (let i = 0; i < 30; i++) {
      this.data.push({
        torokubango: util.padNumber(i.toString(), 4),
        mitsumoriTime: "20200801 13:05:45",
        customerNm: "上",
        shashuKbn: "軽",
        kokusanKbn: "国産"
      });
    }
    this.setDataPage();
  }

  setDataPage() {
    const iStart = (this.currentPage - 1) * this.pageSize;
    const iStop = iStart + this.pageSize;
    const data = this.data.slice(iStart, iStop);
    this.$set(this, "dataPageList", data);
  }

  getJADate(date: string) {
    if (date) {
      let str = util.getJapanDate(date, "YYYYMMDD HH:mm:ss");
      return str.replace(" ", "<wbr/>");
    }
    return "";
  }

  onSelect(row: any) {}

  indexMethod(index: number) {
    return (this.currentPage - 1) * this.pageSize + index + 1;
  }

  handleCurrentChange() {
    this.setDataPage();
  }

  onConfirm() {
    this.$router.push({ name: "quickseibilist" });
  }

  onRowSelect(row: any, event: any, column: any) {
    if (this.torokubangoSelected !== row.torokubango) {
      this.torokubangoSelected = row.torokubango;
    } else {
      this.torokubangoSelected = "";
    }
  }

  tableRowClassName(item: any) {
    if (
      item.row.torokubango === this.torokubangoSelected &&
      this.torokubangoSelected != ""
    ) {
      return "row-selected";
    }
    return "";
  }
}
